const gameTypeMap = {
  SPRING_TRAINING: 'SPRING_TRAINING',
  REGULAR_SEASON: 'REGULAR_SEASON',
  WILD_CARD: 'WILD_CARD',
  DIVISION_SERIES: 'DIVISION_SERIES',
  LEAGUE_CHAMPIONSHIP: 'LEAGUE_CHAMPIONSHIP',
  WORLD_SERIES: 'WORLD_SERIES',
  PLAYOFFS: 'WILD_CARD,DIVISION_SERIES,LEAGUE_CHAMPIONSHIP,WORLD_SERIES',
  ALL_STAR: 'ALL_STAR'
};

const gameTypeFormatter = {
  'SPRING_TRAINING': '"SPRING_TRAINING"',
  'REGULAR_SEASON': '"REGULAR_SEASON"',
  'WILD_CARD': '"WILD_CARD"',
  'DIVISION_SERIES': '"DIVISION_SERIES"',
  'LEAGUE_CHAMPIONSHIP': '"LEAGUE_CHAMPIONSHIP"',
  'WORLD_SERIES': '"WORLD_SERIES"',
  'WILD_CARD,DIVISION_SERIES,LEAGUE_CHAMPIONSHIP,WORLD_SERIES': '"WILD_CARD","DIVISION_SERIES","LEAGUE_CHAMPIONSHIP","WORLD_SERIES"',
  'ALL_STAR': '"ALL_STAR"'
};

const statsApiGameTypeConversions = {
  'S': gameTypeMap.SPRING_TRAINING,
  'R': gameTypeMap.REGULAR_SEASON,
  'F': gameTypeMap.WILD_CARD,
  'D': gameTypeMap.DIVISION_SERIES,
  'L': gameTypeMap.LEAGUE_CHAMPIONSHIP,
  'W': gameTypeMap.WORLD_SERIES,
  'P': gameTypeMap.PLAYOFFS,
  'A': gameTypeMap.ALL_STAR
};

const descriptionGameTypeConversions = {
  'Spring Training': gameTypeMap.SPRING_TRAINING,
  'Regular Season': gameTypeMap.REGULAR_SEASON,
  'Wild Card Game': gameTypeMap.WILD_CARD,
  'Division Series': gameTypeMap.DIVISION_SERIES,
  'League Championship Series': gameTypeMap.LEAGUE_CHAMPIONSHIP,
  'World Series': gameTypeMap.WORLD_SERIES,
  'Playoffs': gameTypeMap.PLAYOFFS,
  'All-Star Game': gameTypeMap.ALL_STAR
};

// Returns a gametype after comparing it against popular alternative formats
const getGameType = (val = '') => {
  return gameTypeFormatter[gameTypeMap[val] || statsApiGameTypeConversions[val] || descriptionGameTypeConversions[val]];
};

module.exports = {
  gameTypeMap,
  getGameType,
  statsApiGameTypeConversions
};
